import { Element, Icon } from 'react-bulma-components';
import { FaArrowRight } from 'react-icons/fa6';
import Button from '../../ui/button/button';
import Modal from '../../ui/modal/modal';

export type SoftwareAssignedConfirmationModalProps = {
  show: boolean;
  onNavigateBackToHome: () => void;
  onKeepAssigningSoftware: () => void;
};

const TITLE = 'Software assigned';
const SUBTITLE =
  'You have successfully assigned the software to your selected devices';
const BACK_BUTTON_TEXT = 'Back to home';
const KEEP_ASSIGNING_SOFTWARE_BUTTON_TEXT = 'Keep assigning software';

export function SoftwareAssignedConfirmationModal({
  show,
  onNavigateBackToHome,
  onKeepAssigningSoftware,
}: SoftwareAssignedConfirmationModalProps) {
  return (
    <Modal show={show} title={TITLE} titleClassName="mb-4">
      <p className="is-size-7">{SUBTITLE}</p>
      <Element
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={8}
      >
        <Button color="primary-dark" outlined onClick={onNavigateBackToHome}>
          {BACK_BUTTON_TEXT}
        </Button>
        <Button color="primary-dark" onClick={onKeepAssigningSoftware}>
          <span>{KEEP_ASSIGNING_SOFTWARE_BUTTON_TEXT}</span>
          <Icon>
            <FaArrowRight />
          </Icon>
        </Button>
      </Element>
    </Modal>
  );
}

export default SoftwareAssignedConfirmationModal;
